import React from 'react'

const FerryServices = () => {
  return (
    <div>FerryServices</div>
  )
}

export default FerryServices